import styled from 'styled-components';

const ObjectFit = styled.div.withConfig({ shouldForwardProp: prop => !['width', 'fit', 'objectPosition'].includes(prop) }) `
  ${({ width }) => width && `
    width: ${width};
  `};
  height: 100%;
  position: relative;
  overflow: hidden;

  video {
    object-fit: contain;
    object-position: ${({ objectPosition }) => (objectPosition ? objectPosition : '50% 50%')};
  }

  img {
    display: block;
  }

  img,
  svg {
    height: 100%;
    ${({ width }) => width && `
      width: ${width};
    `};
    ${({ fit }) => `
      object-fit: ${fit};
    `};
    object-position: ${({ objectPosition }) => (objectPosition ? objectPosition : '50% 50%')};
  }
`;
ObjectFit.defaultProps = {
    fit: 'cover',
    width: '100%',
};

export { ObjectFit };
//# sourceMappingURL=ObjectFit.js.map
